// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"488":"d0d97e3e","701":"c6da34f8"}[chunkId] + ".chunk.js");